import React from 'react'
import { ComponentData } from '../data/ComponentContext'
import { Row, Col } from 'react-bootstrap'

function RemainingPointSlider({ displayErrors }) {

  const { remainingPoints } = ComponentData()

  const trackSections = []
  for (let index = 0; index < 13; index++) {
    trackSections.push(
      <div className={remainingPoints > index ? 'track-section selected' : 'track-section'} key={'track-section-' + index} />
    )
  }

  return (
    <div className={displayErrors && remainingPoints !== 0 ? 'content-box error' : 'content-box'}>
      <Row className="headline_texts">
        <Col md={11}>
          <div className="configuration-text">
            <p>Wird automatisch berechnet</p>
            <h3>Verbleibende Punkte</h3>
          </div>
        </Col>
        <Col md={1}>
          <div className="points">
            <p>{remainingPoints}</p>
          </div>
        </Col>
      </Row>
      <div className="slider-area">
        <input className="slider read-only" type="range" min="0" max="13" value={remainingPoints} readOnly />
        <div className="track-background"></div>
        <div className="track read-only">
          {trackSections}
        </div>
      </div>
      {displayErrors && remainingPoints !== 0 ? <p className='error'>Alle Punkte müssen vergeben werden!</p> : null}
    </div>

  )
}

export default RemainingPointSlider